import { IShellDAO } from '../../dao/IShellDAO';
import { GrantType } from './types';
import { AbstractRepository } from '../AbstractRepository';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export class GrantRepository extends AbstractRepository<GrantType[]> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellGrants',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantRepository',
      methodName: 'saveAll()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  // Keeping signature minimal to avoid unused param lint complaints in noop implementation
  findAll(): GrantType[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantRepository',
      methodName: 'findAll()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'GrantRepository',
      methodName: 'delete()',
      message: 'Not supported in GrantRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
